import { render, staticRenderFns } from "./Stages.vue?vue&type=template&id=61fea478&scoped=true&"
import script from "./Stages.vue?vue&type=script&lang=js&"
export * from "./Stages.vue?vue&type=script&lang=js&"
import style0 from "./Stages.vue?vue&type=style&index=0&id=61fea478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fea478",
  null
  
)

export default component.exports